import CalendarsIndexingGrid from './calendars-indexing-grid';

export default function CalendarsIndexingPage() {
  return <CalendarsIndexingGrid />;
}
